import { FOOTER_LINKS } from '../constants/footer';
import LendoIcon from './LendoIcon';
import LendoOpeningHours from './LendoOpeningHours';
import kundeserviceImage from '../assets/kundeservice_2025.png';
import LendoFooterSocials from './LendoFooterSocials';
import { openCookieSettings } from '../utils/usercentrics';

export function LendoFooterDesktop() {
  const currentYear = new Date().getFullYear();

  const handleLinkClick = (link: any) => {
    if (link.action === 'openCookieSettings') {
      openCookieSettings();
    } else if (link.link) {
      window.location.href = link.link;
    }
  };

  return (
    <div className="lendo-footer-desktop">
      <div className="primary">
        <div className="links always-col">
          <h2 className="section-title">Søk om lån</h2>
          {FOOTER_LINKS.loan.map((link) => (
            <div key={link.title} className="margin-top">
              <a href={link.link} className="lendo-link">
                {link.title}
              </a>
            </div>
          ))}
        </div>

        <div className="links always-col">
          <h2 className="section-title">Få oversikt</h2>
          {FOOTER_LINKS.overview.map((link) => (
            <div key={link.title} className="margin-top">
              <a href={link.link} className="lendo-link">
                {link.title}
              </a>
            </div>
          ))}
        </div>

        <div className="links always-col">
          <h2 className="section-title">Lendo</h2>
          {FOOTER_LINKS.lendo.map((link) => (
            <div key={link.title} className="margin-top">
              {link.action ? (
                <button
                  onClick={() => handleLinkClick(link)}
                  className="lendo-link"
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                >
                  {link.title}
                </button>
              ) : (
                <a href={link.link} className="lendo-link">
                  {link.title}
                </a>
              )}
            </div>
          ))}
        </div>

        <div className="contact">
          <h2 className="section-title">Kundeservice</h2>
          <div className="contact-action margin-top" style={{ marginBottom: '8px' }}>
            <LendoIcon name="icon/phone-icon" size="24px" />
            <a href="tel:22007070">22 00 70 70</a>
          </div>
          <div className="contact-action margin-bottom">
            <LendoIcon name="icon/mail" size="24px" />
            <a href="mailto:kundeservice@lendo.no">kundeservice@lendo.no</a>
          </div>
          <div>
            <div>
              I åpningstiden kan du ringe eller chatte med oss, og du kan når som helst sende en mail.
            </div>
            <div className="mt-4">
              <img src={kundeserviceImage} width="80px" alt="Kundeservice bilde" />
            </div>
          </div>
        </div>
        <LendoOpeningHours />
      </div>

      <div className="secondary">
        <div className="description">
          Vi er en markedsplass hvor du kan søke og sammenligne tilbud fra flere banker i én søknad. Slik at du kan finne det beste tilbudet for deg. Tjenestene våre er gratis og uforpliktende.
        </div>
        <div className="divider" />
        <div className="bottom-section">
          <div className="always-col">
            <div>&copy; {currentYear} Lendo AS</div>
            <div>Org. nr 997 523 814</div>
          </div>
          <div className="always-col">
            <div>Hagegata 22</div>
            <div>0653 OSLO</div>
          </div>
          <LendoFooterSocials />
          <LendoIcon name="logo" size="30px" />
        </div>
      </div>
    </div>
  );
}
